import { createAction, props } from '@ngrx/store';
import { ITerminalUser } from 'src/app/features/settings/models/user.model';

export const LoadUsersAction = createAction('[UserManagement] Load Users');

export const UserManagementLoaded = createAction(
  '[User Management] User Management Component Loaded',
);

export const StoreUsersAction = createAction(
  '[User Management] Store Users',
  props<{ users: ITerminalUser[] }>(),
);

export const LoadUsersErrorAction = createAction(
  '[User Management] Load Users Error',
  props<{ error: string }>(),
);

export const DeactivateUserAction = createAction(
  '[User Management] Deactivate User',
  props<{ user: ITerminalUser; isFTW: boolean }>(),
);

export const DeactivateUserSuccessAction = createAction(
  '[User Management] Deactivate User Success',
  props<{ user: ITerminalUser }>(),
);

export const DeactivateUserErrorAction = createAction(
  '[User Management] Deactivate User Error',
  props<{ error: string }>(),
);

export const ResendUserInviteAction = createAction(
  '[User Management] Resend User Invite',
  props<{ user: ITerminalUser; delayInvite?: boolean }>(),
);

export const ResendUserInviteSuccessAction = createAction(
  '[User Management] Resend User Invite Success',
  props<{ user: ITerminalUser }>(),
);

export const ResendUserInviteErrorAction = createAction(
  '[User Management] Resend User Invite Error',
  props<{ error: string }>(),
);

export const AddUserAction = createAction(
  '[User Management] Add User',
  props<{ user: ITerminalUser; delayInvite?: boolean }>(),
);

export const AddUserSuccessAction = createAction(
  '[User Management] Add User Success',
  props<{ user: ITerminalUser }>(),
);

export const UpdateUserAction = createAction(
  '[User Management] Update User',
  props<{ user: ITerminalUser; isFTW: boolean }>(),
);

export const UpdateUserSuccessAction = createAction(
  '[User Management] Update User Success',
  props<{ user: ITerminalUser }>(),
);

export const UserSaveErrorAction = createAction(
  '[User Management] Add or Update User Error',
  props<{ error: string }>(),
);
